import React, { useId } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import SoftButton from "../../../components/SoftButton";
import SoftTypography from "../../../components/SoftTypography";
import { useDisclosure } from "../../../hooks/useDisclosure";
import { useAddBrandNotification } from "../../settings/hooks";

/** Clears the brand webhook URL after confirmation, preserving the brand and its other settings. */
const DeleteWebhook = ({ brand }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate, isLoading } = useAddBrandNotification();
  const titleId = useId();
  const descriptionId = useId();

  const handleDelete = () => {
    mutate({ brandId: brand._id, notificationUrl: null }, { onSuccess: onClose });
  };

  return (
    <>
      <SoftButton
        variant="outlined"
        color="error"
        size="small"
        onClick={onOpen}
        disabled={isLoading}
      >
        Delete
      </SoftButton>
      <Dialog
        open={isOpen}
        onClose={isLoading ? undefined : onClose}
        fullWidth
        maxWidth="xs"
        aria-labelledby={titleId}
        aria-describedby={descriptionId}
      >
        <DialogTitle id={titleId}>Delete webhook?</DialogTitle>
        <DialogContent>
          <SoftTypography
            id={descriptionId}
            component="p"
            variant="body2"
            color="text"
            sx={{ mt: 2, overflowWrap: "anywhere" }}
          >
            Remove the default webhook URL for <strong>{brand.name}</strong>? Webhook URLs provided
            in payment payloads will still apply.
          </SoftTypography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <SoftButton variant="outlined" onClick={onClose} disabled={isLoading} autoFocus>
            Cancel
          </SoftButton>
          <SoftButton
            color="error"
            onClick={handleDelete}
            disabled={isLoading}
            isLoading={isLoading}
          >
            Delete
          </SoftButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

DeleteWebhook.propTypes = {
  brand: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default DeleteWebhook;
